module.exports = __webpack_public_path__ + "img/loginBg.d4c80fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginBg.png
// module id = FSht
// module chunks = 4